import { CompanyIntegrationPipe } from './company.integration.pipe';

export function CompanyIntegrationFilter ( companyIntegrationPipe : CompanyIntegrationPipe ) {
  return ( value : string ) : string => companyIntegrationPipe.transform(value);
};